import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach token from localStorage as fallback
http.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("wv_token");
  if (t) cfg.headers = { ...cfg.headers, Authorization: `Bearer ${t}` };
  return cfg;
});

// Map Pydantic field names to NL labels so validation errors read naturally
const FIELD_LABELS = {
  email: "E-mailadres",
  password: "Wachtwoord",
  name: "Naam",
  phone: "Telefoon",
  country: "Land",
  role: "Rol",
  message: "Bericht",
  subject: "Onderwerp",
  amount: "Bedrag",
  address: "Adres",
  city: "Plaats",
  postal_code: "Postcode",
  price: "Prijs",
};

export function formatApiError(e) {
  // Network / CORS error (no response from server)
  if (e?.message === "Network Error" || !e?.response) {
    return "Verbinding met de server mislukt. Controleer uw internetverbinding en probeer opnieuw.";
  }
  const status = e.response.status;
  const d = e.response.data?.detail;
  // FastAPI validation errors come as array of {loc, msg, type}
  if (Array.isArray(d) && d.length > 0) {
    const lines = d.map((x) => {
      const field = Array.isArray(x?.loc) ? x.loc[x.loc.length - 1] : null;
      const label = (field && FIELD_LABELS[field]) || field || "";
      const msg = x?.msg || "";
      // Drop pydantic 'Value error, ' prefix for prettier NL output
      const cleaned = msg.replace(/^Value error,\s*/i, "");
      return label ? `${label}: ${cleaned}` : cleaned;
    });
    return lines.join(" · ");
  }
  if (typeof d === "string") return d;
  if (d?.msg) return d.msg;
  if (status === 401) return "Niet ingelogd of ongeldige inloggegevens.";
  if (status === 403) return d || "Toegang geweigerd.";
  if (status === 404) return "Niet gevonden.";
  if (status >= 500) return "Server-fout. Probeer het later opnieuw of neem contact op via info@woonverder.eu.";
  return e?.message || "Er ging iets mis. Probeer het opnieuw.";
}
